import { createContext } from 'react';

const loadingContext = createContext({
  loading: false,
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  setLoading: (flag: boolean) => {}
});

export default loadingContext;
